import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import { WIDGET_STATE } from '../../constants/app';
import { MESSENGER_BUTTON } from '../../constants/dimensions';
import ProactiveMessages from './proactive-messages';

ProactiveMessagesContainer.propTypes = {
    widgetState: PropTypes.symbol.isRequired,
    buttonHeight: PropTypes.string,
};

function ProactiveMessagesContainer({ widgetState, buttonHeight }) {

    const style = {
        paddingBottom: buttonHeight || MESSENGER_BUTTON.DEFAULT_HEIGHT,
    };

    const renderProactiveMessages = () => {
        if (widgetState === WIDGET_STATE.OPENED) {
            return null;
        }

        return (
            <CSSTransition
                    key={ 'proactive-messages' }
                    classNames='bb-proactive-messages-container'
                    appear={true}
                    timeout={200}>
                <div>
                    <ProactiveMessages />
                </div>
            </CSSTransition>
        );
    };

    return (
        <div id='bb-proactive-messages-container'>
            <div style={ style }>
                <TransitionGroup>
                    { renderProactiveMessages() }
                </TransitionGroup>
            </div>
        </div>
    );
}

export default connect(({ appState: { widgetState }, config: { buttonHeight } }) => ({
    widgetState,
    buttonHeight,
}))(ProactiveMessagesContainer);

